import { render } from "./BNavRouterLink.vue?vue&type=template&id=6f713eea"
import script from "./BNavRouterLink.vue?vue&type=script&lang=js"
export * from "./BNavRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__